<div class="container">
  <p-table #userlist [columns]="cols" [value]="users" [lazy]="true" (onLazyLoad)="loadUsersLazy($event)" [paginator]="true"
           [rows]="100" [totalRecords]="totalRecords" [loading]="loading" dataKey="UserName">
    <ng-template pTemplate="caption" [style]="{'height':'30px !important'}">
      <div style="height: 30px; width: 100%">
        <span class="float-left">User List</span>
        <div class="float-right" style="margin-left: 20px;">
          <a (click)="openUserEdit('')" class="text-white" style="font-size:24px; cursor:pointer" *hasClaim="'User_Edit'" title="Add User"><i class="fa-plus fa"></i> </a>
          <a (click)="loadUsersLazy(null)" class="text-white" style="font-size:24px; cursor:pointer; margin-left: 5px;" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i> </a>
        </div>
        <div class="float-right">
          <input pInputText type="text" (keypress)="handleSearchKey($event, userlist)" placeholder="User Search" />
        </div>
      </div>  
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pSortableColumn="UserName">User Name <p-sortIcon field="UserName"></p-sortIcon></th>
        <th pSortableColumn="FirstName">First Name <p-sortIcon field="FirstName"></p-sortIcon></th>
        <th pSortableColumn="LastName">Last Name <p-sortIcon field="LastName"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td>
          <a style="cursor: pointer; margin-left:5px;" (click)="openUserEdit(rowData.UserName)">
            {{rowData.UserName}}
          </a>
        </td>
        <td>
          {{rowData.FirstName}}
        </td>
        <td>
          {{rowData.LastName}}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
